module.exports = __webpack_public_path__ + "img/coin_grab_red.3807691e.png";